import { filterNavItemsByRole } from "src/helpers";
import { navItems } from "src/constants";
import { Wrapper } from "src/types";
import { useAuthentication, useAuthorisation } from "src/context";
import { useFeedback } from "src/hooks";
import { FeedbackModal } from "src/components/modals/users";
import { SidebarProvider } from "src/shadcn/ui/sidebar";
import { AppSidebar } from "./appSidebar";
import { TopNavbar } from "./topNavbar";

const MainLayout: Wrapper = ({ route, children }) => {
  const { userRole } = useAuthorisation();
  const { logout } = useAuthentication();

  const { isFeedbackModalOpen, isLoading, validationErrors, formLvlErrorMessage, submitFeedback } = useFeedback();

  const roleBasedNavItems = filterNavItemsByRole(navItems, userRole);

  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex h-screen w-full overflow-hidden bg-gray-50">
        <aside className="shrink-0 border-r bg-white shadow-sm">
          <AppSidebar navItems={roleBasedNavItems} onLogout={logout} />
        </aside>
        <div className="flex flex-col flex-1 overflow-hidden">
          <TopNavbar routeName={route} />

          <main className="flex-1 overflow-y-auto">{children}</main>
        </div>
      </div>

      {isFeedbackModalOpen && userRole === "VENDOR" && (
        <FeedbackModal
          isOpen={isFeedbackModalOpen}
          onSubmit={submitFeedback}
          isLoading={isLoading}
          validationErrors={validationErrors}
          formLvlErrorMessage={formLvlErrorMessage}
        />
      )}
    </SidebarProvider>
  );
};

export { MainLayout };
